<!--
  Generated template for the GpsPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>{{'GPSPosition' | translate}}</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <google-maps (updateData)="updateGeoData($event)"
                 [activeItem]="patientDataProvider.activePatientData.geoPlace"
                 [fallbackAddress]="patientDataProvider.activePatientData.addressData"
                 [management]="patientDataProvider.activePatientData.management"></google-maps>
</div>
